"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.spinnerStrokeWidths = exports.spinnerSizes = exports.spinnerDefaultProps = exports.rotateKeyframes = void 0;
var _react = require("@emotion/react");
var _interfaces = require("./interfaces");
const spinnerSizes = exports.spinnerSizes = {
  [_interfaces.SpinnerSize.ExtraSmall]: 16,
  [_interfaces.SpinnerSize.Small]: 28,
  [_interfaces.SpinnerSize.Medium]: 70,
  [_interfaces.SpinnerSize.Large]: 104
};
const spinnerStrokeWidths = exports.spinnerStrokeWidths = {
  [_interfaces.SpinnerSize.ExtraSmall]: 4,
  [_interfaces.SpinnerSize.Small]: 4,
  [_interfaces.SpinnerSize.Medium]: 6,
  [_interfaces.SpinnerSize.Large]: 8
};
const rotateKeyframes = exports.rotateKeyframes = (0, _react.keyframes)({
  from: {
    transform: 'rotate(0deg)'
  },
  to: {
    transform: 'rotate(360deg)'
  }
});
const spinnerDefaultProps = exports.spinnerDefaultProps = {
  colorScheme: _interfaces.SpinnerColorScheme.Default,
  margin: 0,
  loadingText: 'Loading...',
  showText: false,
  fontSize: 'T100',
  size: _interfaces.SpinnerSize.Small
};